export const USER_CREATED = "USER_CREATED"
export const USERS_FETCHED = "USERS_FETCHED"
export const PUBLIC_LOGGED = "PUBLIC_LOGGED"
